import React, { useRef } from 'react';
import cx from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styles from './Dropdown.module.scss';
import { Button } from '../Button';
import { ChevronIcon } from '../Accordion/ChevronIcon';
import { useSafeId } from '../../core/hooks/useSafeId';
import { useToggle } from '../../core/hooks/useToggle';
import { Content } from './Content';
export var Dropdown = function (_a) {
    var _b;
    var children = _a.children, _c = _a.closeOnClick, closeOnClick = _c === void 0 ? false : _c, _d = _a.closeOnScroll, closeOnScroll = _d === void 0 ? false : _d, direction = _a.direction, _e = _a.disabled, disabled = _e === void 0 ? false : _e, handleItemSelect = _a.handleItemSelect, isOpen = _a.isOpen, label = _a.label, onClose = _a.onClose, onOpen = _a.onOpen, _f = _a.width, width = _f === void 0 ? 'fit' : _f;
    var buttonRef = useRef(null);
    var contentRef = useRef(null);
    var buttonId = useSafeId();
    var dropdownContentId = useSafeId();
    var _g = useToggle(false), localIsOpen = _g[0], open = _g[1], close = _g[2];
    var isControlled = useRef(isOpen !== undefined);
    var isDropdownOpened = isControlled.current ? isOpen : localIsOpen;
    var handleClose = function (event, focusButton) {
        if (focusButton === void 0) { focusButton = true; }
        if (buttonRef.current && focusButton) {
            buttonRef.current.focus();
        }
        if (onClose) {
            onClose(event);
        }
        close();
        event.preventDefault();
    };
    var handleOpen = function (event) {
        if (onOpen) {
            onOpen(event);
        }
        open();
    };
    var toggleOpen = function (event) {
        return isDropdownOpened ? handleClose(event) : handleOpen(event);
    };
    var handleKeyDown = function (event) {
        if (['ArrowUp', 'ArrowDown'].includes(event.key)) {
            handleOpen(event);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { "aria-controls": dropdownContentId, "aria-expanded": isDropdownOpened, className: cx(styles.dropdownButton, (_b = {}, _b[styles.disabled] = disabled, _b)), disabled: disabled, endIcon: React.createElement(ChevronIcon, { isOpen: isDropdownOpened }), id: buttonId, onClick: toggleOpen, onKeyDown: handleKeyDown, ref: buttonRef, theme: "secondary", width: width }, label),
        !disabled && (React.createElement(TransitionGroup, null, isDropdownOpened && (React.createElement(CSSTransition, { nodeRef: contentRef, classNames: {
                enter: styles.contentEnter,
                enterActive: styles.contentEnterActive,
                exit: styles.contentExit,
                exitActive: styles.contentExitActive,
            }, timeout: { enter: 150, exit: 150 } },
            React.createElement(Content, { "aria-labelledby": buttonId, closeOnClick: closeOnClick, closeOnScroll: closeOnScroll, direction: direction, id: dropdownContentId, handleClose: handleClose, handleItemSelect: handleItemSelect, referenceElement: buttonRef, ref: contentRef }, children)))))));
};
//# sourceMappingURL=Dropdown.js.map